import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideToast } from './toastSlice';
import { RootState } from '../../store';
import Image from '../images/Image';
import { motion, AnimatePresence, time } from 'framer-motion';

const Toast: React.FC = () => {
  const dispatch = useDispatch();

  // Access the toast slice from the state using RootState
  const { type, message, timestamp, isVisible } = useSelector((state: RootState) => state.toast);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 7000); // 10 seconds

      return () => clearTimeout(timer);
    }
  }, [isVisible, timestamp, dispatch]);

  const typeClasses = {
    success: 'bg-positive_light border-positive',
    error: 'bg-negative_light border-negative',
    warning: 'bg-warning_light border-warning',
    info: 'bg-information_light border-information',
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: 50 }} // Starting position
          animate={{ opacity: 1, x: 0 }} // Animation when visible
          exit={{ opacity: 0, x: 50 }} // Animation when exiting
          transition={{ duration: 0.5 }} // Smooth transition
          className={`fixed flex top-5 right-5 z-50 border-l-10 border-2 p-4 rounded-lg shadow-lg gap-2 ${
            typeClasses[type]
          }`}
        >
          <Image src={type} className='object-none' />
          <p className="pr-2 text-primary_text text-body1 max-w-[600px] break-all" data-testid={`${message?.toLowerCase().replace(/ /g, '-')}`}>{message}</p>
          <Image
            src={'close'}
            onClick={() => dispatch(hideToast())}
            className="cursor-pointer object-none"
            testId='close-toast'
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;
